var _a;
import { DEVICE_TYPE } from '../../constants/commonConstants';
import getDeviceType from './getDeviceType/getDeviceType';
var apiUrl = 'https://api.tving.com';
var userUrl = 'https://user.tving.com';
var searchUrl = 'https://search.tving.com';
var imageServerUrl = 'https://image.tving.com';
var ttvUrl = 'https://image.tving.com/upload/ttv/status.json';
var bufferUrl = 'https://image.tving.com/upload/buffer/status.json';
var gatewayUrl = 'https://gw.tving.com';
var regionGatewayUrl = 'https://ooo-gw.tving.com';
var amplitudeKey = 'c2b31201837521f7cfb798a47bd43043';
var versionUrl = typeof window !== 'undefined' ? "".concat(window === null || window === void 0 ? void 0 : window.location.protocol, "//").concat(window === null || window === void 0 ? void 0 : window.location.host, "/version.json") : '';
export var API_TYPES;
(function (API_TYPES) {
    API_TYPES["PRODUCTION"] = "PRODUCTION";
    API_TYPES["QC"] = "QC";
    API_TYPES["QA"] = "QA";
    API_TYPES["DEV"] = "DEV";
})(API_TYPES || (API_TYPES = {}));
var ApiTypes = function (apiType) {
    switch (apiType) {
        case 'PRODUCTION':
        case 'real':
            return 'PRODUCTION';
        case 'QC':
        case 'qc':
            return 'QC';
        case 'QA':
        case 'qa':
            return 'QA';
        case 'DEV':
        case 'dev':
            return 'DEV';
        default:
            return 'PRODUCTION';
    }
};
var environment = (_a = process.env.REACT_APP_RELEASE) !== null && _a !== void 0 ? _a : 'PRODUCTION';
// Api type A.K.A at
var storedApiType = typeof window !== 'undefined' ? localStorage.getItem('at') : null;
var apiType = storedApiType !== null && storedApiType !== void 0 ? storedApiType : ApiTypes(environment);
switch (apiType) {
    case API_TYPES.PRODUCTION:
        apiUrl = 'https://api.tving.com';
        userUrl = 'https://user.tving.com';
        searchUrl = 'https://search.tving.com';
        imageServerUrl = 'https://image.tving.com';
        ttvUrl = 'https://image.tving.com/upload/ttv/status.json';
        bufferUrl = 'https://image.tving.com/upload/buffer/status.json';
        gatewayUrl = 'https://gw.tving.com';
        regionGatewayUrl = 'https://ooo-gw.tving.com';
        amplitudeKey = 'c2b31201837521f7cfb798a47bd43043';
        break;
    case API_TYPES.QC:
        apiUrl = 'https://apiqc.tving.com';
        userUrl = 'https://userqc.tving.com';
        searchUrl = 'https://qc-search.tving.com';
        imageServerUrl = 'https://image.tving.com';
        ttvUrl = 'https://image.tving.com/upload/ttv/status.json';
        bufferUrl = 'https://image.tving.com/upload/buffer/status.json';
        gatewayUrl = 'https://gw-qc-cf.aws.tving.com';
        regionGatewayUrl = 'https://ooo-gw-qc.aws.tving.com';
        amplitudeKey = '22ae6386ed7c9bcb4d25c135d61e293f';
        break;
    case API_TYPES.QA:
        apiUrl = 'https://apiqa.tving.com';
        userUrl = 'https://userqa.tving.com';
        searchUrl = 'https://qa-search.tving.com';
        imageServerUrl = 'https://image-qa.tving.com';
        ttvUrl = 'https://image-qa.tving.com/upload/ttvstg/status.json';
        bufferUrl = 'https://image-qa.tving.com/upload/bufferstg/status.json';
        gatewayUrl = 'https://gw-qa-cf.aws.tving.com';
        regionGatewayUrl = 'https://ooo-gw-qa.aws.tving.com';
        amplitudeKey = '22ae6386ed7c9bcb4d25c135d61e293f';
        break;
    case API_TYPES.DEV:
        apiUrl = 'https://apidev.tving.com';
        userUrl = 'https://userdev.tving.com';
        searchUrl = 'https://dev-search.tving.com';
        imageServerUrl = 'https://imagedev.tving.com';
        ttvUrl = 'https://imagedev.tving.com/upload/ttvdev/status.json';
        bufferUrl = 'https://imagedev.tving.com/upload/bufferdev/status.json';
        gatewayUrl = 'https://gw-dev-cf.aws.tving.com';
        regionGatewayUrl = 'https://ooo-gw-dev.aws.tving.com';
        amplitudeKey = 'b6c94c8cc95de692d32ff315f4f9057c';
        break;
    default:
}
var deviceType = getDeviceType();
// eslint-disable-next-line no-nested-ternary
export var POC_CODE = deviceType === DEVICE_TYPE.WEBOS ? 'POCD0800' : deviceType === DEVICE_TYPE.TIZEN ? 'POCD0801' : 'POCD0802';
// eslint-disable-next-line no-nested-ternary
export var SCREEN_CODE = deviceType === DEVICE_TYPE.WEBOS ? 'CSSD1100' : deviceType === DEVICE_TYPE.TIZEN ? 'CSSD1200' : 'CSSD1300';
export var API_KEY = 
// eslint-disable-next-line no-nested-ternary
deviceType === DEVICE_TYPE.WEBOS
    ? '95a64ebcd8e154aeb96928bf34848826'
    : deviceType === DEVICE_TYPE.TIZEN
        ? 'aeef9047f92b9dc4ebabc71fe4b124bf'
        : '1e7952d0917d6aab1f0293a063697610';
export var API_SERVER_URL = "".concat(apiUrl);
export var USER_SERVER_URL = "".concat(userUrl);
export var SEARCH_SERVER_URL = "".concat(searchUrl);
export var IMAGE_SERVER_URL = "".concat(imageServerUrl);
export var TTV_URL = "".concat(ttvUrl);
export var BUFFER_URL = "".concat(bufferUrl);
export var VERSION_URL = "".concat(versionUrl);
export var GATEWAY_URL = "".concat(gatewayUrl);
export var REGION_GATEWAY_URL = "".concat(regionGatewayUrl);
export var AMPLITUDE_KEY = "".concat(amplitudeKey);
